import * as React from "react";
import {LegacyChipButton} from "../../../../components/buttons/LegacyChipButton";
import {borderRadius, ColorPalette, getChipColor, renderCheckBox, SpecificAlarmFilterProps} from "./Commons";

import {AppTranslations} from "../../../../components/Utils/translations/AppTranslations";
import "./SeverityFilter.scss";
import {ChipButton} from "../../../../components/buttons/ChipButton";

declare var AppTranslations: AppTranslations;

export interface SeverityOption {
    urgent: boolean;
    high: boolean;
    warning: boolean;
}

export class SeverityFilter extends React.Component<SpecificAlarmFilterProps, any> {

    constructor(props) {
        super(props);
        this.props.resetter((optionsDefaults: SeverityOption) => {
            Object.keys(optionsDefaults).forEach((id) => {
                this.onSeverityChange(id)(optionsDefaults[id]);
            });
        });
    }

    public render() {
        const AlarmsFilterTranslations = AppTranslations.equipmentAlarmFilter;
        return (
            <>
                <div className={"filter-form-column"}>
                    <p className={"filter-field-name"}>{AlarmsFilterTranslations.severityLabel}</p>
                    <div className={"group-wrapper severities"}>
                        {this.renderSeverity(AlarmsFilterTranslations.urgentSeverityLabel, "urgent", "#ef5350")}
                        {this.renderSeverity(AlarmsFilterTranslations.highSeverityLabel, "high", "#ff9800")}
                        {this.renderSeverity(AlarmsFilterTranslations.warningSeverityLabel, "warning", "#ffeb3b")}
                    </div>
                </div>
            </>
        );
    }

    private renderSeverity = (text: string, id: string, circleColor: string) => {
        return (
            <div className={"column-box"}>
                <ChipButton
                    label={text}
                    checked={this.props.filter.alarmSeverity[id]}
                    disabled={this.props.disabled}
                    onChange={this.onSeverityChange(id)}
                    color={getChipColor(this.props.disabled, this.props.filter.alarmSeverity[id])}
                    accentColor={circleColor}
                />
            </div>
        );
    }

    private onSeverityChange = (id: string) => {
        return (_) => {
            const futureSeverities = {
                ...this.props.filter.alarmSeverity,
                [id]: !this.props.filter.alarmSeverity,
            };
            if (!futureSeverities.high && !futureSeverities.warning && !futureSeverities.urgent) {
                return;
            }
            this.props.onFilterConfigChanged({
                ...this.props.filter,
                alarmSeverity: {
                    ...this.props.filter.alarmSeverity,
                    [id]: !this.props.filter.alarmSeverity[id],
                },
            });
        };
    }

}
